import { isDev } from './is-dev';
export function devWarning(api, message) {
  if (isDev) {
    console.warn("[@bcz/fe-interface: ".concat(api, "] ").concat(message));
  }
}
export function devError(api, message) {
  if (isDev) {
    console.error("[@bcz/fe-interface: ".concat(api, "] ").concat(message));
  }
}